import "./Kontakty.css";
import { Helmet } from "react-helmet-async";
import { Button } from "@ceskastranaasocialu/komponenty";
import TwitterProfile from "../../components/TwitterProfile/TwitterProfile";
import InstagramProfile from "../../components/InstagramProfile/InstagramProfile";
import kontaktyTitle from "../../images/Titles/web_nadpis-kontakty2.webp"
import DyskordLogo from "../../images/DyskordLogo.svg";
import YoutubeLogo from "../../images/YoutubeLogo.svg";
import KickLogo from "../../images/kicklogo.svg"
import MastodonLogo from "../../images/MastodonLogo.svg"
import BlueskyLogo from "../../images/BlueskyLogo.svg"
import TruthsocialLogo from "../../images/TruthsocialLogo.svg"
import FacebookLogo from "../../images/FacebookLogo.svg"
import InstagramLogo from "../../images/instagramLogo.svg"


export default function Kontakty() {
  return (
    <div id="contactsContent">
      <Helmet>
        <title>Kontakty · ČSA</title>
        <meta name="description" content="ČSA je recesistická politická strana, jejíž cílem, pokud ti to ještě nedošlo, je naprostá asocializace společnosti a České republiky. Chození ven způsobilo války, neštěstí a zmar, proto tu jsou asociálové, aby vše napravili. HLAVNĚ TO PROBOHA NEBERTE VÁŽNĚ, JSME RECESISTI!" />
        <meta property="og:title" content="Kontakty · ČSA" />
        <meta property="og:description" content="ČSA je recesistická politická strana, jejíž cílem, pokud ti to ještě nedošlo, je naprostá asocializace společnosti a České republiky. Chození ven způsobilo války, neštěstí a zmar, proto tu jsou asociálové, aby vše napravili. HLAVNĚ TO PROBOHA NEBERTE VÁŽNĚ, JSME RECESISTI!" />
        <meta property="og:image" content={`${process.env.PUBLIC_URL}/assets/banner.png`} />
        <meta property="og:url" content="https://www.asocialove.cz/#/path" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Kontakty · ČSA" />
        <meta name="twitter:description" content="ČSA je recesistická politická strana, jejíž cílem, pokud ti to ještě nedošlo, je naprostá asocializace společnosti a České republiky. Chození ven způsobilo války, neštěstí a zmar, proto tu jsou asociálové, aby vše napravili. HLAVNĚ TO PROBOHA NEBERTE VÁŽNĚ, JSME RECESISTI!" />
        <meta name="twitter:image" content={`${process.env.PUBLIC_URL}/assets/banner.png`} />
      </Helmet>

        <div className="kontaktyTitle">
          <img src={kontaktyTitle} alt="" draggable="false" />
        </div>

      <div className="kontaktyPruh kontaktyPruhZelena">
        <p className="kontaktyNadpis">Socky</p>
        <div id="profilesWrapper">
          <TwitterProfile/>
          <InstagramProfile/>
          </div>
      </div>

      <div className="kontaktyPruh kontaktyPruhRuzova">
        <p className="kontaktyNadpis">Pošta</p>
        <div className="kontaktyButtony">
          <Button as="a" variant="dark" highlight href="mailto:strana@asocialove.cz">
             <span className="material-symbols-outlined">mail</span>
            strana@asocialove.cz
            </Button>
        </div>
        <p>ID datové schránky: 4vhhxyi</p>
        <p>Pokud náhodou chcete posílat fyzický dopis: Svornosti 881, Liberec 30, 463 11</p>
      </div>

      <div className="kontaktyPruh kontaktyPruhZelena">
        <p className="kontaktyNadpis">Kinematografie a videotvorba</p>
        <div className="kontaktyButtony">
          <Button as="a" variant="dark" highlight href="https://www.youtube.com/@ceskastranaasocialu" target="_blank" rel="noopener noreferrer">
           <img className="kontaktyLogo" src={YoutubeLogo} alt=""/>
          Youtube
          </Button>
          <Button as="a" variant="dark" highlight href="https://kick.com/ceska-strana-asocialu" target="_blank" rel="noopener noreferrer">
          <img className="kontaktyLogo" src={KickLogo} alt=""/>
          Kick
          </Button>
        </div>
      </div>

      <div className="kontaktyPruh kontaktyPruhRuzova">
        <p className="kontaktyNadpis">Discord server</p>
        <p>Kdybyste se někdy chtěli bavit s podporovateli strany. Jinak tohle má svou vlastní kategorii, protože nevim, kam jinam server strany zařadit.</p>
        <div className="kontaktyButtony">
          <Button as="a" className="kontaktyButton" variant="dark" highlight href="https://discord.gg/E5RK8VKpyT" target="_blank" rel="noopener noreferrer">
          <img className="kontaktyLogo" src={DyskordLogo} alt=""/>
          Discord server
          </Button>
        </div>
      </div>

      <div className="kontaktyPruh kontaktyPruhZelena">
        <p className="kontaktyNadpis">Nepoužívané socky</p>
        <p>Tohle byl projekt bývalého předsedy Konráda Koulemastníka. Chtěl využít socky, který nikdo nepoužívá/nepoužíval. Tohle je hodně niche věc btw. Trvalo to od 1. 3. do 21. 3. 2025.</p>
        <div className="kontaktyButtony">
          <Button as="a" variant="dark" highlight href="https://mastodon.social/@ceskastranaasocialu@pixelfed.social" target="_blank" rel="noopener noreferrer">
          <img className="kontaktyLogo" src={MastodonLogo} alt=""/>
          Mamut
          </Button>
          <Button as="a" variant="dark" highlight href="https://bsky.app/profile/ceskastranaasocial.bsky.social" target="_blank" rel="noopener noreferrer">
          <img className="kontaktyLogo" src={BlueskyLogo} alt=""/>
          Modroobloha
          </Button>
          <Button as="a" variant="dark" highlight href="https://truthsocial.com/@ceskastranaasocialu" target="_blank" rel="noopener noreferrer">
          <img className="kontaktyLogo" src={TruthsocialLogo} alt=""/>
          Taková ta trumpova síť
          </Button>
        </div>
        <p>Facebook slouží jen k repostování příspěvků z instagramu. Tahle síť je tak moc zanedbaná a nepoužívaná</p>
        <div className="kontaktyButtony">
           <Button as="a" variant="dark" highlight href="https://www.facebook.com/profile.php?id=61582914953606&locale=cs_CZ" target="_blank" rel="noopener noreferrer">
          <img className="kontaktyLogo" src={FacebookLogo} alt=""/>
          Ksichtobichle 
          </Button>
        </div>
      </div>

      <div className="kontaktyPruh kontaktyPruhRuzova">
        <p className="kontaktyNadpis">Administrace webu</p>
        <div className="kontaktyButtony">
          <Button as="a" variant="dark" highlight href="https://www.instagram.com/web_ceskestranyasocialu/" target="_blank" rel="noopener noreferrer">
            <img className="kontaktyLogo" src={InstagramLogo} alt=""/>
            Instantní Gram
          </Button>
          <Button as="a" variant="dark" highlight href="mailto:admin@asocialove.cz">
            <span className="material-symbols-outlined">mail</span>
            admin@asocialove.cz
          </Button>
        </div>
        <p>O web se starají tihle skvělí lidé: Rachel, Neto, Nox</p>
      </div>
    </div>
  );
}
